export function getTierLabel(tier) {
  switch (tier) {
    case 1:
      return "Basic";
    case 2:
      return "Advanced";
    case 3:
      return "Premium";
    default:
      return "Unknown"; // fallback for unexpected values
  }
}